<template>
	<div class="w-100">
		<span id="top_section"></span>
		<div v-if="is_load" class="w-100 py-4 text-center">
      <loader />
    </div>
    <template v-else>
    	<div class="p-4" v-if="error != ''">
      	<ErrorMessage :message="error" />
    	</div>
    	<template v-else>
    		<!-- IF OUTSTANDING IS 0 -->
		    <warning-box 
      		v-if="data.total_outstanding == 0"
      		title="PAID"
      		body="Your bill has been paid"
      		btn_primary="Order Again"
      		@yes="goBack">
      	</warning-box>

    		<!-- HEADER -->
				<wrapper-mobile-view>
					<div class="w-100 bg-green py-3 px-4 border-b-semi-grey">
						<p class="mb-0 body-1-2 text-white">Payment Bill</p>
					</div>
				</wrapper-mobile-view>
				<block :height="57" />

				<!-- DETAIL ITEM -->
				<div class="px-4 w-100">
					<p class="mb-4 body-1-4">Order Summary</p>
					<div class="w-100">
						<div class="w-100" :class="{ 'border-b-semi-grey-dashed-2 mb-4 pb-4' : product_i+1 < data.detail.length }" v-for="(product,product_i) in data.detail">
							<div class="row no-gutters">
								<div class="col-1">
									<p class="text-14 text-center font-lato w-100 py-2 radius-6 border-form bg-grey-dark lh-1">{{ product.qty }}x</p>
								</div>
								<div class="col-7">
									<div class="pl-3">
										<p class="mb-0 body-2-1">{{ product.name }}</p>
										<p class="body-3-3-1 mb-1 w-100">Note : <b>{{ product.remark }}</b></p>
									</div>
								</div>
								<div class="col-4 text-right">
									<!-- <p class="mb-0 text-12 font-lato text-semi-light text-line-through" v-if="product.price_discount > 0">{{ $formatCurrency(product.base_price) }}</p> -->
									<p class="mb-0 text-14 font-lato">{{ printPrice(product) }}</p>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="w-100 my-4" style="height: 8px;background-color: #EEE;"></div>

				<!-- CUSTOMER DETAIL -->
				<div class="px-4 w-100" id="contact_section">
					<p class="mb-0 body-1-4">Contact Information</p>
					<p class="mb-3 body-3-3-1">Some payment methods require your contact information</p>
					<div class="w-100">
						<GuestForm ref="guestForm" type="PAYMENT_BILL"></GuestForm>
					</div>
					<span id="mid_section"></span>
				</div>
				<div class="w-100 my-4" style="height: 8px;background-color: #EEE;"></div>

				<!-- PRICE DETAIL -->
				<div class="px-4 w-100">
					<p class="mb-0 body-1-4">Price Details</p>
          <p class="mb-3 body-3-3-1">Review the cost breakdown before finalizing.</p>
					<div class="row slim-grid-row mb-2">
            <div class="col-7 align-self-center">
              <p class="mb-0 body-2-1">Subtotal</p>
            </div>
            <div class="col-5 text-right align-self-center">
              <p class="mb-0 font-lato text-14">{{$formatCurrency(data.total_outstanding+data.total_discount-(data.total_taxes+data.total_service))}}</p>
            </div>
          </div>
					<div class="row slim-grid-row mb-2">
            <div class="col-7 align-self-center">
              <p class="mb-0 body-2-1">Discount</p>
            </div>
            <div class="col-5 text-right align-self-center">
              <p class="mb-0 font-lato text-14" :class="{'text-orange':data.total_discount > 0}">{{$formatCurrency(data.total_discount)}}</p>
            </div>
          </div>
					<div class="row slim-grid-row mb-2">
            <div class="col-7 align-self-center">
              <p class="mb-0 body-2-1">Taxes</p>
            </div>
            <div class="col-5 text-right align-self-center">
              <p class="mb-0 font-lato text-14">{{$formatCurrency(data.total_taxes)}}</p>
            </div>
          </div>
					<div class="row slim-grid-row mb-2">
            <div class="col-7 align-self-center">
              <p class="mb-0 body-2-1">Service</p>
            </div>
            <div class="col-5 text-right align-self-center">
              <p class="mb-0 font-lato text-14">{{$formatCurrency(data.total_service)}}</p>
            </div>
          </div>
					<div class="row slim-grid-row mb-2" v-if="getPaymentSurcharge > 0">
            <div class="col-7 align-self-center">
              <p class="mb-0 body-2-1">Payment Surcharge</p>
            </div>
            <div class="col-5 text-right align-self-center">
              <p class="mb-0 font-lato text-14">{{$formatCurrency(getPaymentSurcharge)}}</p>
            </div>
          </div>
					<div class="border-b-semi-grey-dashed-2 w-100 my-3"></div>
          <div class="row slim-grid-row" id="for-payment-section">
            <div class="col-6">
              <p class="mb-0 body-1-4">Total</p>
            </div>
            <div class="col-6 text-right">
              <p class="mb-0 font-lato text-16">{{ $formatCurrency(data.total_outstanding+getPaymentSurcharge) }}</p>
            </div>
          </div>
				</div>
				<div class="w-100 my-4" style="height: 8px;background-color: #EEE;"></div>
				
				<!-- PAYMENT METHODS -->
				<div class="px-4 w-100 mb-4">
					<p class="mb-0 body-1-4">Payment Method</p>
					<p class="mb-3 body-3-3-1">Choose a payment method according to your needs</p>
					<p class="w-100 mb-2 mt-1 body-3 text-danger" v-if="payment_method.error != ''">Please select payment method</p>
					<div class="w-100">
						<PaymentMethod ref="payment_method" module="restaurant" @selectPayment="selectPayment"></PaymentMethod>
					</div>
				</div>

				<!-- BUTTON BOOKING -->
				<block :height="100" />
				<wrapper-mobile-view fixed_position="bottom">
					<div class="w-100 p-4 bg-white">
						<p v-if="error_push != ''" class="mb-2 body-3-3-1 text-danger"><i class="simple-icon-exclamation mr-1"></i> {{error_push}}</p>
						<state-button
							variant="secondary"
							size="xl"
							block
							:click="submitPayment">
							PAY NOW
						</state-button>
					</div>
				</wrapper-mobile-view>

				<!-- XENDIT CC FORM -->
				<popup-detail 
		    	direction="bottom" 
		    	:show="show_xendit_form"
		    	wrapper_size="full"
		    	:no_close_backdrop="true"
		    	@close="toggleXenditForm">
		    	<template v-slot:body>
		    		<div class="p-4">
		    			<XenditInputCC
		    				v-if="show_xendit_form"
                :tx_payment="result_tx_payment.payment"
                module_page="RESTAURANT"
								submodule_page="BILL"
                @done="goToPageResult"
                @expired="toggleXenditForm">
              </XenditInputCC>
		    		</div>
		    	</template>
		    </popup-detail>
    	</template>
    </template>
	</div>
</template>
<script>
	import {get,post} from '@/services/index.js'
	import {mapGetters,mapMutations} from 'vuex'
	import config from '@/config/index.js';
	import XenditInputCC from '@/components/hotel/be/XenditInputCC';
	import { validationMixin } from "vuelidate";
  const { required, email } = require("vuelidate/lib/validators");
	import PaymentMethod from '@/components/general/payment/PaymentMethod';
	import GuestForm from '@/components/restaurant-v2/GuestForm';

	export default{
		components:{
			XenditInputCC,
			PaymentMethod,
			GuestForm
		},
		data(){
			return{
				is_load: true,
				error: '',
				data: {},
				payment_method:{
					list: [],
					selected: {},
					error: ''
				},
				customer_detail:{
          name: '',
          email: '',
          phone_number: ''
        },
        form_validation:{
          name: '',
          email: '',
          phone_number: ''
        },
        error_push: '',
        result_tx_payment:{},
	      show_xendit_form: false
			}
		},
		mixins: [validationMixin],
    validations: {
      customer_detail:{
        name:{
          required
        },
        email:{
          required,
          email
        },
        phone_number:{
          required
        },
      }
    },
		computed:{
			...mapGetters(['getMerchant','getRestaurantCustomer']),
			invoice_id(){
				return this.$route.params.invoice_id
			},
			getPaymentSurcharge(){
				let total = 0

				if(this.payment_method.selected.id){
					if(this.payment_method.selected.surcharge_type == 'PERCENT'){
						total = (this.data.total_outstanding/100)*this.payment_method.selected.surcharge_value
					}else{
						total = this.payment_method.selected.surcharge_value
					}
				}

				return total
			},
			is_cc_va(){
				if(this.payment_method.selected.id && (this.payment_method.selected.payment_method == 'CREDIT_CARD' || this.payment_method.selected.payment_method == 'VIRTUAL_ACCOUNT')){
					return true
				}
				return false
			},
		},
		mounted(){
			this.loadFirstData()
		},
		methods:{
			...mapMutations(['resetRestaurantCustomerDetail']),
			loadDetailInvoice(){
				return new Promise((success,fail)=>{
					get("CORE_RESTO",`orderbil/tx-history/${this.invoice_id}`,
						{
							merchant_id: this.getMerchant.id
						}).then(response=>{
						let res = response.data
						if(res.success){
							success(res.data)
						}else{
							fail(res.message)
						}
					})
				})
			},
			loadFirstData(){
				this.is_load = true
				this.error = ''
				this.data = {}
				Promise.all([
					this.loadDetailInvoice()
				])
				.then(res=>{
					this.data = res[0]
				})
				.catch(err=>this.error=err)
				.finally(()=>this.is_load=false)
			},
			scrollTo(id){
        document.getElementById(id).scrollIntoView({
          behavior: 'smooth'
        });
      },
      goBack(){
      	this.$router.push(`/${this.getMerchant.code}`)
      },
      printPrice(data){
      	return this.$formatCurrency(data.price-data.discount+data.taxes+data.service)
      },
      goToPageResult(){
      	this.$router.push({
	        name: 'RestaurantPaymentResult',
	        params:{
	        	merchant_code: this.getMerchant.code,
	          tx_payment_id : this.result_tx_payment.tx_order_id
	        }
	      })
      },
      toggleXenditForm(){
      	this.show_xendit_form = !this.show_xendit_form
      	if(!this.show_xendit_form){
      		this.result_tx_payment = {}
      	}
      },
			selectPayment(pm){
				this.payment_method.selected = pm
			},
			submitPayment(){
				return new Promise((success,fail)=>{
					this.payment_method.error = ''
					this.$refs.guestForm.validateForm().then(() => {
						if(this.payment_method.selected.id){
							let params = {
								merchant_id: this.getMerchant.id,
								tx_order_id: this.invoice_id,
								amount: this.data.total_outstanding+this.getPaymentSurcharge,
								customer_detail: this.getRestaurantCustomer,
								payment_details: {
									id: this.payment_method.selected.id,
									payment_method: this.payment_method.selected.payment_method,
									bank_name: this.payment_method.selected.bank_name,
									payment_channel: this.payment_method.selected.payment_channel
								}
							}
							post("CORE_RESTO", "orderbil/tx-payment", params).then(response=>{
								let res = response.data
								if(res.success){
									this.resetRestaurantCustomerDetail()
									let bank_name = this.payment_method.selected.bank_name
									let payment_type = this.payment_method.selected.payment_method
									this.result_tx_payment = res
									this.result_tx_payment.payment.tx_order_id_2 = res.tx_order_id
									if(bank_name == 'JOKUL_DOKU'){
										if(payment_type == 'VIRTUAL_ACCOUNT'){
											this.goToPageResult()
										}else{
											loadJokulCheckout(res.payment.url)
										}
									}else if(this.payment_method.selected.bank_name == 'MIDTRANS'){
										let scriptTag = document.createElement('script');
										scriptTag.src = config.MIDTRANS_URL
										scriptTag.setAttribute('data-client-key', res.payment.client_key);
										document.head.appendChild(scriptTag);
										scriptTag.onload = function(){
											window.snap.pay(res.payment.token)
										}
									}else if(this.payment_method.selected.bank_name == 'XENDIT' && this.payment_method.selected.payment_method == 'CREDIT_CARD'){
										this.show_xendit_form = true
									}else{
										this.goToPageResult()
									}
									success()
								}else{
									fail()
								}
							})
						}else{
							this.$smoothScroll('mid_section')
							this.payment_method.error = 'required'
							fail()
						}
					}).catch(err=>{
						this.$smoothScroll('top_section')
            fail()
					})
				})
			}
		}
	}
</script>


// WEBPACK FOOTER //
// src/pages/restaurant/PaymentBillGeneral.vue